module.exports = __webpack_public_path__ + "img/01.5e8c46cd.png";